export const widgetIds = {
    main: {
        feed: {
            prevPc: "33866",
            prevMob: "33866",
            fullPc: "null",
            fullMob: "null",
        },
        json: {
            fullPc: "31590",
            fullMob: "34545",
            prevPc: "31588",
            prevMob: "31587",
        },
        backClick: "31597",
        moeVideo: {
            fullPc: null,
            fullMob: 13139,
            prevPc: null,
            prevMob: null,
        },
        yaFloorAd: "R-A-1598227-215",
        popup: "30231",
        refresh: "lp48306_new",
    },
    48306: {
        feed: {
            prevPc: "33866",
            prevMob: "33866",
            fullPc: "null",
            fullMob: "null",
        },
        json: {
            fullPc: "31590",
            fullMob: "34545",
            prevPc: "31588",
            prevMob: "31587",
        },
        backClick: "31597",
        moeVideo: {
            fullPc: null,
            fullMob: 13139,
            prevPc: null,
            prevMob: null,
        },
        yaFloorAd: "R-A-1598227-215",
        popup: "30231",
        refresh: "lp48306_new",
    },
    2: {
        feed: {
            prevPc: "36111",
            prevMob: "36111",
            fullPc: "36111",
            fullMob: "36111",
        },
        json: {
            fullPc: "36111",
            fullMob: "36111",
            prevPc: "36111",
            prevMob: "36111",
        },
    },
    3: {
        feed: {
            prevPc: "36112",
            prevMob: "36112",
            fullPc: "36112",
            fullMob: "36112",
        },
        json: {
            fullPc: "36112",
            fullMob: "36112",
            prevPc: "36112",
            prevMob: "36112",
        },
    },
    4: {
        json: {
            fullPc: "36113",
            fullMob: "36113",
            prevPc: "36113",
            prevMob: "36113",
        },
    },
    5: {
        json: {
            prevPc: "36130",
            prevMob: "36130",
            fullPc: "36130",
            fullMob: "36130",
        },
        refresh: "lp48306_new_5",
    },
    66972: {
        backClick: "37412",
        refresh: "lp48306_66972",
        json: {
            fullPc: "37411",
            fullMob: "37411",
            prevPc: "37411",
            prevMob: "37411",
        },
        moeVideo: {
            fullPc: null,
            fullMob: 12367,
            prevPc: null,
            prevMob: 12367,
        },
    },
};
